URL={
  "add":"/platform/resourceperm/resourcemng/add",//新增 
  "modify":"/platform/resourceperm/resourcemng/modify",//修改资源
  "list":"/platform/resourceperm/resourcemng/find",//列表
  "find":"/platform/resourceperm/resourcemng/select",//查找
  "delete":"/platform/resourceperm/resourcemng/delete"//删除
};


/**
 * 加载平台资源树
 * @param {回调函数} cb 
 */
async function loadPlatResourceTree(data,cb){
  debugger;
  if(!data){
      return;
  }
  let resResult = await this.$post(URL.list,data);
  if(cb&&resResult){
    let treeData
    if (resResult.status && resResult.data.list) {
      treeData = recursionTree(resResult.data.list, 0);
      cb(treeData);
    } else {
      cb([]);
    }
  }else{
    cb([]);
  }
}

/**
 * 加载平台资源树
 * @param {回调函数} cb 
 */
async function addPlatResource(data,cb){
  if(!data){
      return;
  }
  let postUrl = URL.add;
  if(data.isEdit) postUrl = URL.modify;
  // console.log(postUrl)
  // return
  let resResult = await this.$post(postUrl,data);
  if(cb&&resResult){
    cb(resResult)
    // console.log(resResult)
  }else{
    cb([]);
    this.$message.error(resResult.msg);
  }
}

/**
 * 删除平台资源
 * @param {*} data 
 * @param {*} cb 
 */
async function delPlatResource(data,cb){
  if(!data){
      return;
  }
  console.log(data)
  let resResult = await this.$post(URL.delete,data);
  console.log(resResult)
  if(cb&&resResult){
    cb(resResult)
  }else{
    cb([]);
  }
}


/**
 * 数据递归为树状结构
 * @param {*} data 
 * @param {*} parent 
 * @param {*} level 
 */
function  recursionTree(data, parent, level = 0) {
  level++;
  var tree = [];
  var temp;
  for (var i = 0; i < data.length; i++) {
    if (data[i].parentResourceId == parent) {
      let levelStr = "";
      for (var j = 1; j < level; j++) {
        levelStr = levelStr + "|- ";
      }
      data[i].level = level;
      data[i].value = levelStr + data[i].resourceName;
      var obj = data[i];
      temp = recursionTree(data, data[i].resourceId, level);
      if (temp.length > 0) {
        obj.children = temp;
      }
      tree.push(obj);
    }
  }
  return tree;
}


export default {
  loadPlatResourceTree,
  addPlatResource,
  delPlatResource
}